import React from 'react'
import DefaultForm from '../../../../ui/forms/default-form'
import RemoteTypeAheadSelect from '../../../../ui/forms/type-ahead'
import { hasAvailableAction } from '../../../../ui/gov-actions'

const available = record => hasAvailableAction(record, 'match_parent')

const apiEndPoint = ({ gov_id }) =>
  process.env.REACT_APP_API_HOST + `/api/ccs-enrolments/${gov_id}/associate-parent`

const validate = ({ care_id }) => !!care_id

const formValue = 'ccs_match_parent'
const formLabel = 'Confirm Matching Parent'

const matchParentForm = ({ record }) => ({ handleSuccess }) => (
  <DefaultForm
    url={apiEndPoint(record)}
    name={formValue}
    label={formLabel}
    handleSuccess={() => handleSuccess({ [formValue]: 'The parent has been matched' }, formValue)}
    formOptions={{ validate, defaultOptions: { care_id: '' } }}
    formComponent={({ onChange, errors }) => (
      <RemoteTypeAheadSelect
        name="care_id"
        label="Parents"
        required
        hint="Select a parent in Xplor"
        onChange={onChange}
        errors={errors.parents}
        apiEndPoint={`/api/ccs-enrolments/${record.gov_id}/parents`}
        optionsFilter={options => options}
      />
    )}
  />
)

export const confirmMatchingParent = ({ record }) =>
  available(record)
    ? {
      label: formLabel,
      value: formValue,
      actionForm: matchParentForm({ record }),
    }
    : null



// WEBPACK FOOTER //
// ./src/care-enrolments/details/ccs-gov-enrolments/actions/confim-matching-parent.js